export function initHomehero(homehero: HTMLElement) {

	let button1 = homehero.querySelector('[data-part="button1"]');
	if (button1) {
		button1.addEventListener('click', (e) => {
			e.preventDefault();
			if (window['OJNew']) {
				window['OJNew'].showFreeCoursePopup();
			}
		})
	}

	let button2 = homehero.querySelector('[data-part="button2"]');
	if (button2) {
		button2.addEventListener('click', (e) => {
			e.preventDefault();
			let target = homehero.querySelector('[data-part="bottom"]');
			if (target) {
				target.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}
		});
	}

	setTimeout(
		() => {
			homehero.classList.remove('homehero--loading');
		},
		50
	);

}
